import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=1465d852&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=1465d852&lang=scss&scoped=true&"
import style1 from "./addOrEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465d852",
  null
  
)

export default component.exports